<script setup>
import _ from 'lodash'
import { useRouter } from 'vue-router'
import FormButton from '../../components/Atoms/FormButton.vue'
import FormSwitch from '../../components/Atoms/FormSwitch.vue'
import IconBase from '../../components/icon/IconBase.vue'
import IconChevronDown from '../../components/icon/IconChevronDown.vue';
import IconCheckmark from '../icon/IconCheckmark.vue'
import SubscribePlanItem from './SubscribePlanItem.vue';
import SubscribePlansCustomWidget from './SubscribePlansCustomWidget.vue';
import IconChevronRight from '../icon/IconChevronRight.vue'

const props = defineProps({
  subscriptionPackages: {
    type: Array,
  },
  plansData: {
    type: Array,
  },
  productType: {
    type: String,
  },
  shouldShowCompare: {
    type: Boolean
  }
})

const router = useRouter()

const yearly = defineModel('yearly')

//Methods
const goToSubscribe = () => router.push({ path: '/subscribe' })

</script>

<template>
  <div class="relative w-full xl:w-11/12 2xl:w-10/12 mx-auto" data-testid="subscribe-plans">
    <div v-if="productType !== 'ott'"
      class="flex flex-col items-center gap-2 mb-8 sticky xl:static top-16 z-20">
      <div class="max-w-full flex flex-wrap items-center justify-center gap-x-3 gap-y-2 bg-surface-2 ring-1 ring-surface-3 rounded-xl sm:rounded-full py-2 px-3 sm:pl-4 shadow-lg">
        <span class="text-sm transition-colors" :class="!yearly ? 'text-white font-medium' : 'text-surface-6'">Monthly</span>
        <FormSwitch v-model="yearly" data-testid="subscribe-cycle-toggle" />
        <span class="text-sm transition-colors" :class="yearly ? 'text-white font-medium' : 'text-surface-6'">Yearly</span>
        <span class="text-tiny font-semibold text-gold bg-warning-transparent rounded-full px-2 py-0.5">Save up to 20%</span>
      </div>
      <p class="text-tiny text-surface-7 font-medium">+ more concurrent streams on yearly plans</p>
    </div>
    <div v-if="!plansData?.length"
      class="bg-surface-2 ring-1 ring-surface-3 rounded-xl py-12 px-4 text-center">
      <p class="text-surface-9 font-medium">No plans are available for the {{ yearly ? 'yearly' : 'monthly' }} billing
        cycle.</p>
      <p v-if="productType !== 'ott'" class="text-surface-6 text-sm mt-1">Switch the billing cycle above to see the
        other plans.</p>
    </div>
    <div v-else class="grid grid-cols-1 md:grid-cols-2 gap-4 xl:gap-5 items-start xl:pt-3"
      :class="productType === 'ott' ? 'xl:grid-cols-4' : 'xl:grid-cols-5'">
      <SubscribePlanItem v-for="(plan, index) in plansData" :key="index" :plan="plan" :is-yearly="yearly"
        :product-type="productType" />
    </div>
    <div v-if="productType === 'ott'" class="mt-5 grid grid-cols-1 lg:grid-cols-2 gap-4 bg-surface-2 ring-1 ring-surface-3 rounded-xl p-4 text-surface-8 text-sm leading-6">
      <ul class="flex items-center flex-wrap gap-x-4 gap-y-1 md:justify-center">
        <li class="flex items-center gap-x-2">
          <icon-base class="text-success" width="16" height="16" fill="none">
            <IconCheckmark />
          </icon-base>
          Live Streaming Bandwidth
        </li>
        <li class="flex items-center gap-x-2">
          <icon-base class="text-success" width="16" height="16" fill="none">
            <IconCheckmark />
          </icon-base>
          Video Hosting Storage
        </li>
      </ul>
      <div>
        <p class="font-medium">Based on Castr live streaming tiers.
          <FormButton customClasses="inline-flex items-center text-main hover:text-main-light hover:no-underline" href="https://castr.com/pricing-ott/" target="_blank">
            See Pricing
            <icon-base>
              <IconChevronRight />
            </icon-base>
          </FormButton>
        </p>
        <p class="text-surface-6">* Minimum Premium Tier Required.</p>
      </div>
    </div>
    <div class="flex items-center justify-center mt-6">
      <FormButton v-if="shouldShowCompare" target="_self" href="app/subscribe#compare"
        customClasses="text-surface-8 hover:text-white text-sm flex items-center gap-x-2">
        Compare Plans
        <IconBase>
          <IconChevronDown />
        </IconBase>
      </FormButton>
      <FormButton v-else @click="goToSubscribe" customClasses="text-surface-8 hover:text-white text-sm flex items-center gap-x-2">
        See full features
        <IconBase>
          <IconChevronDown />
        </IconBase>
      </FormButton>
    </div>
    <SubscribePlansCustomWidget class="absolute left-full -ml-2 top-20 !hidden xl:!block" />
  </div>
</template>

<style></style>
